<div class="container">
    <div class="row">
        <div class="col-lg-8 offset-2">
            <section class="centered--carga">
                <h3 class="fw-bold" align="center">{{ title }}</h3>
                <p class="text-center">{{ description }}</p>
                <br>

                <!-- Barra de carga -->
                <div class="barra--carga">
                    <div id="load-bar" class="move"></div>
                </div>
                <!-- ./ Barra de carga -->
            </section>
        </div>
    </div>
</div>
